import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
import { useTheme } from "@catchoftheday/theme";
import { Flex } from "../Flex";
import { IconAlert, IconTick, IconToolTip, IconWarning } from "../Icon";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var INLINE_ALERT_VARIANT_MAP = {
  error: {
    theme: {
      dark: {
        color: "white",
        iconColor: "white",
        backgroundColor: "error"
      },
      light: {
        color: "text",
        iconColor: "error",
        backgroundColor: "#FCE9E9"
      }
    },
    icon: IconAlert
  },
  warning: {
    theme: {
      dark: {
        color: "text",
        iconColor: "text",
        backgroundColor: "warning"
      },
      light: {
        color: "text",
        iconColor: "warning",
        backgroundColor: "#FEF3DE"
      }
    },
    icon: IconWarning
  },
  success: {
    theme: {
      dark: {
        color: "white",
        iconColor: "white",
        backgroundColor: "primary"
      },
      light: {
        color: "text",
        iconColor: "primary",
        backgroundColor: "#F0FAE6"
      }
    },
    icon: IconTick
  },
  info: {
    theme: {
      dark: {
        color: "white",
        iconColor: "white",
        backgroundColor: "secondary"
      },
      light: {
        color: "text",
        iconColor: "secondary",
        backgroundColor: "#D0E8FF"
      }
    },
    icon: IconToolTip
  },
  "default": {
    theme: {
      dark: {
        color: "white",
        iconColor: "white",
        backgroundColor: "text"
      },
      light: {
        color: "white",
        iconColor: "white",
        backgroundColor: "text"
      }
    },
    icon: IconToolTip
  }
};
export var InlineAlert = function InlineAlert(_ref) {
  var _icon$props$height, _icon$props$width, _containerProps$borde, _cgTheme$maxWidths$co;

  var variant = _ref.variant,
      containerProps = _ref.containerProps,
      _showAlertIcon = _ref.showAlertIcon,
      _ref$alignIcon = _ref.alignIcon,
      alignIcon = _ref$alignIcon === void 0 ? "center" : _ref$alignIcon,
      _icon = _ref.icon,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? "light" : _ref$theme,
      children = _ref.children;
  var cgTheme = useTheme();
  var showAlertIcon = _showAlertIcon !== null && _showAlertIcon !== void 0 ? _showAlertIcon : Boolean(_icon);
  var AlertIcon = INLINE_ALERT_VARIANT_MAP[variant].icon;
  var iconColor = INLINE_ALERT_VARIANT_MAP[variant].theme[theme].iconColor;
  var color = INLINE_ALERT_VARIANT_MAP[variant].theme[theme].color;
  var backgroundColor = INLINE_ALERT_VARIANT_MAP[variant].theme[theme].backgroundColor;
  var icon = _icon ? /*#__PURE__*/React.cloneElement(_icon, {
    height: (_icon$props$height = _icon.props.height) !== null && _icon$props$height !== void 0 ? _icon$props$height : "20px",
    width: (_icon$props$width = _icon.props.width) !== null && _icon$props$width !== void 0 ? _icon$props$width : "20px"
  }) : undefined;
  return ___EmotionJSX(Flex, {
    role: "alert",
    width: "auto",
    borderRadius: (_containerProps$borde = containerProps === null || containerProps === void 0 ? void 0 : containerProps.borderRadius) !== null && _containerProps$borde !== void 0 ? _containerProps$borde : "default",
    color: color,
    backgroundColor: backgroundColor
  }, ___EmotionJSX(Flex, {
    position: "relative",
    marginX: "auto",
    width: "100%",
    maxWidth: (_cgTheme$maxWidths$co = cgTheme.maxWidths.cotdWebsite) !== null && _cgTheme$maxWidths$co !== void 0 ? _cgTheme$maxWidths$co : cgTheme.maxWidths["default"]
  }, showAlertIcon && ___EmotionJSX(Flex, {
    alignItems: alignIcon,
    py: 3,
    pl: {
      xs: 2,
      lg: 3
    },
    color: iconColor
  }, icon !== null && icon !== void 0 ? icon : ___EmotionJSX(AlertIcon, {
    height: "20px",
    width: "20px"
  })), ___EmotionJSX(Flex, _extends({
    alignItems: "center",
    fontSize: {
      xs: "xs",
      lg: "base"
    },
    fontWeight: "normal",
    py: {
      xs: 2,
      lg: 3
    },
    pl: 3,
    pr: 5
  }, containerProps), children)));
};